<template>
    <Row type="none" class="bg-white rounded shadow">

        <div class="container pt-3">
            <GoBackButtonRow/>
        </div>

        <div class="grid grid-cols-12 gap-3 container py-5">
            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{ $t('printView.receipt') }}
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    {{ this.$route.params.id}}
                </div>
            </div>

            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{$t('customer.title')}}
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    {{supplier}}
                </div>
            </div>

            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{$t('returnProducts.saleDate')}}
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    {{ dateTimeFormat(purchaseCreatedAt, true) }}
                </div>
            </div>

            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{$t('returnProducts.returnAmount')}}
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    {{totalAmount }}
                </div>
            </div>

            <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-4 position-relative">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{$t('returnProducts.returnSum')}}
                </div>
                <div class="pt-2 pl-3 font-bold text-gray-500">
                    {{ showCurrencyById(refundPriceCurrency, totalRefundPrice) }}
                </div>
            </div>
        </div>



        <div v-for="(purchaseRefund, index) of getProductRefund" :key="index" class="pb-4">
            <table class="w-full">
                <thead class="bg-lightGray h-11">
                    <tr>
                        <th class="d-none d-sm-table-cell pl-3">#</th>
                        <th>{{ $t('product.title') }}</th>
                        <th>{{ $t('amount') }}</th>
                        <th>{{ $t('returnProducts.returnAmount') }}</th>
                        <th class="d-none d-sm-table-cell">{{ $t('price') }}</th>
                        <th>{{ $t('sale.sum') }}</th>
                    </tr>
                </thead>
                <tbody
                    v-for="(productPurchase, index) in purchaseRefund.productPurchaseRefunds"
                    :key="index"
                >
                <tr class="h-11">
                    <td class="d-none d-sm-table-cell pl-3"> {{productPurchase.id}}</td>
                    <td class="font-bold text-main">{{productPurchase.product.name}}</td>
                    <td>
                        {{ parseFloat(productPurchase.amount) + ' ' + showUnitOfMeasure(productPurchase.product.unitOfMeasure) }}
                    </td>
                    <td>
                        {{parseFloat(productPurchase.amount) + ' ' + showUnitOfMeasure(productPurchase.product.unitOfMeasure)}}
                    </td>
                    <td class="d-none d-sm-table-cell">
                        {{ showCurrencyById(purchaseRefund.refundCurrency.id, productPurchase.price / productPurchase.amount) }}
                    </td>
                    <td>
                        {{ showCurrencyById(purchaseRefund.refundCurrency.id, productPurchase.price) }}
                    </td>
                </tr>
                </tbody>
            </table>

            <div class="grid grid-cols-12 gap-3 container mt-5 pb-3">
                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('returnProducts.returnDate')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ dateTimeFormat(purchaseRefund.createdAt, true) }}
                    </div>
                </div>

                <div class="border border-gray-700 rounded h-11 col-span-12 md:col-span-6 position-relative">
                    <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                        {{$t('returnProducts.returnSum')}}
                    </div>
                    <div class="pt-2 pl-3 font-bold text-gray-500">
                        {{ showCurrencyById(purchaseRefund.refundCurrency.id, purchaseRefund.refundPrice) }}
                    </div>
                </div>
            </div>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Row from "../../components/html/Row";
import currencyRateMixin from "@/mixin/currencyRateMixin";
import currencyFormatMixin from "@/mixin/currencyFormatMixin";
import dateFormatting from "@/mixin/dateFormattingMixin";
import accessMixin from "@/mixin/accessMixin";
import GoBackButtonRow from "@/components/GoBackButtonRow";

export default {
    name: "SaleRefund",
    components: {
        GoBackButtonRow,
        Row,
    },
    mixins: [currencyFormatMixin, currencyRateMixin, dateFormatting, accessMixin],
    data() {
        return {
            totalRefundPrice: 0,
            totalAmount: 0,
            purchaseCreatedAt: 0,
            supplier: null,
            refundPriceCurrency: null,
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'returnProducts.return', url: 'purchase-refund'},
            ],
        }
    },
    computed: {
        ...mapGetters(['getProductRefund']),
    },
    methods: {
        ...mapActions(['fetchPurchaseRefund', 'setBreadcrumbItems']),
        getSupplierName(item) {
            return item.supplier.isCompany ?
                item.supplier.supplierCompany.name :
                item.supplier.person.givenName + ' ' + item.supplier.person.familyName
        },
        colTotalRefundPrice() {
            for(let purchaseRefund of this.getProductRefund) {
                this.supplier = this.getSupplierName(purchaseRefund)
                this.purchaseCreatedAt = purchaseRefund.purchase.createdAt
                this.totalAmount += purchaseRefund.productPurchaseRefunds.length
                this.refundPriceCurrency = purchaseRefund.refundCurrency.id
                this.totalRefundPrice += parseFloat(purchaseRefund.refundPrice)
            }
        }
    },
    created() {
        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        this.fetchPurchaseRefund(this.$route.params.id)
            .then(() => {
                this.colTotalRefundPrice()
            })

    },
}
</script>

<style scoped>
.text-light span {
    font-size: 12px;
}

.list-product .right {
    text-align: right;
}

.list-product .center {
    text-align: center;
}

.input-amount {
    border-top: 1px solid #c5c5c5;
    border-bottom: 1px solid #c5c5c5;
    box-shadow: none !important;
    height: 22px;
}

.minus {
    background-color: #6f42c1;
    cursor: pointer;
    padding-left: 3px;
}

.plus {
    background-color: #6f42c1;
    cursor: pointer;
}

.awesome-icon-amount {
    color: #FFFFFF;
    font-weight: 100;
    font-size: 15px;
}

.product-card > span {
    display: flex;
    justify-content: center;
    justify-self: center;
    margin-top: 6px;
}
</style>
